import styled from "styled-components";
import { size, theme } from "../../../helpers/theme";
import Icon from "../../../components/icon";
import { ReactComponent as CheckedRounded } from "../../../assets/icons/forklift-with-truck.svg";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const OfferInitialAcceptance = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/");
    }, 10000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <OfferInitialAcceptanceContainer>
      <IconWrapper>
        <Icon width={"200px"} height={"200px"} icon={<CheckedRounded />} />
      </IconWrapper>

      <ThankForInitialAcceptance>
        Dziękujemy za wstępną akceptację przygotowanej oferty. Co dalej?
      </ThankForInitialAcceptance>
      <InformationalFieldsWrapper>
        <InformationalField>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
          mollis molestie lacinia. Morbi odio enim, ultricies at eleifend ut,
          elementum quis neque. Vivamus vel leo lobortis, efficitur orci ac,
          volutpat turpis
        </InformationalField>
        <InformationalField>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
          mollis molestie lacinia. Morbi odio enim, ultricies at eleifend ut,
          elementum quis neque. Vivamus vel leo lobortis, efficitur orci ac,
          volutpat turpis
        </InformationalField>
      </InformationalFieldsWrapper>
    </OfferInitialAcceptanceContainer>
  );
};

export default OfferInitialAcceptance;

const OfferInitialAcceptanceContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  flex-direction: column;
  @media (min-width: ${size.laptop}) {
    margin-left: 20px;
    margin-top: 100px;
  }
`;
const ThankForInitialAcceptance = styled.div`
  width: 78%;
  text-align: center;
  font-family: ${theme.fonts.interBold};
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
`;
const IconWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
const InformationalFieldsWrapper = styled.div`
  width: 100%;
  @media (min-width: ${size.laptop}) {
    width: 80%;
  }
  //max-width: 800px;
  display: flex;
  gap: 20px;
  justify-content: center;
  margin-top: 30px;
  margin-bottom: 50px;
  flex-wrap: wrap;
`;
const InformationalField = styled.div`
  @media (min-width: ${size.laptop}) {
    width: 360px;
  }
  width: 300px;
  display: flex;
  justify-content: flex-start;
  background-color: white;
  border-radius: 16px;
  padding: 20px;
`;
